<p>
  recharge-search-form works!
</p>
